/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - Distributor Management
=========================================================
*/

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useDistributor from "hooks/useDistributor";

export default function data() {
  const navigate = useNavigate();
  const { getdistributorList, deletedistributor, distributorList } = useDistributor();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState({});

  const handleDeleteDistributor = async (distributorId) => {
    if (window.confirm("Are you sure you want to delete this distributor?")) {
      setLoading((prev) => ({
        ...prev,
        [distributorId]: { ...prev[distributorId], delete: true },
      }));
      try {
        const res = await deletedistributor(distributorId);
        if (res.success) {
          alert("Distributor deleted successfully!");
          fetchList();
        }
      } catch (err) {
        console.error("Error deleting distributor:", err);
        alert("An error occurred while deleting the distributor.");
      } finally {
        setLoading((prev) => ({
          ...prev,
          [distributorId]: { ...prev[distributorId], delete: false },
        }));
      }
    }
  };

  const DistributorActions = ({ onEdit, onDelete, distributorId }) => (
    <MDBox display="flex" justifyContent="center">
      <MDButton variant="contained" color="info" onClick={onEdit} sx={{ mr: 1 }}>
        <EditIcon />
      </MDButton>
      <MDButton
        variant="contained"
        color="error"
        onClick={onDelete}
        sx={{ mr: 1 }}
        disabled={loading[distributorId]?.delete}
      >
        <DeleteIcon />
      </MDButton>
    </MDBox>
  );

  const DistributorInfo = ({ name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption" color="text" display="block">
          Email Address: {email}
        </MDTypography>
      </MDBox>
    </MDBox>
  );

  const rows = data?.map((distributor) => ({
    distributor: <DistributorInfo name={distributor.name} email={distributor.email} />,
    email: (
      <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
        {distributor.email}
      </MDTypography>
    ),
    primaryPhoneNo: (
      <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
        {distributor.primaryPhoneNo}
      </MDTypography>
    ),
    image: (
      <img
        src={distributor.image}
        alt="Preview"
        style={{ height: "50px", width: "50px", objectFit: "contain" }}
      />
    ),
    actions: (
      <DistributorActions
        distributorId={distributor._id}
        onEdit={() => navigate(`/distributor-management/edit?id=${distributor._id}`)}
        onDelete={() => handleDeleteDistributor(distributor._id)}
      />
    ),
  }));

  const fetchList = async () => {
    await getdistributorList();
  };

  useEffect(() => {
    if (distributorList.distributers) {
      setData(distributorList.distributers);
    }
  }, [distributorList]);

  return {
    columns: [
      { Header: "Distributor", accessor: "distributor", width: "30%", align: "left" },
      { Header: "Email", accessor: "email", align: "center" },
      { Header: "Mobile", accessor: "primaryPhoneNo", align: "center" },
      { Header: "Image", accessor: "image", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],
    rows,
  };
}
